import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    { path: '', redirectTo: 'DNT-registration', pathMatch: 'full' },
     //{ path: 'registration', loadChildren: () => import('./registration/registration.module').then(m => m.RegistrationPageModule)  },
    //{ path: 'qr-viewer', loadChildren: () => import('./qr-viewer/qr-viewer.module').then(m => m.QrViewerPageModule) },
   { path: 'DNT-registration', loadChildren: () => import('./DNT-registration/DNT-registration.module').then(m => m.DNTRegistrationPageModule) },
    { path: 'DNT-qr-viewer', loadChildren: () => import('./DNT-qr-viewer/DNT-qr-viewer.module').then(m => m.DNTQrViewerPageModule) }
];



@NgModule({
        imports: [RouterModule.forRoot(routes, { useHash: true /*,  preloadingStrategy: PreloadAllModules */})],
    exports: [RouterModule]
})
export class AppRoutingModule { }
